import { Action, Dispatch } from 'redux'
import { openModalAction } from 'reducks/modal/actions'

const openModal = (content: React.ReactElement, title: string, description = '') => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openModalAction(content, description, title))
  }
}

export default openModal
